var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSphere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 9.17157C22.9763 10.7337 22.9763 13.2663 19.071 14.8284C15.1658 16.3905 8.83413 16.3905 4.92893 14.8284C1.02369 13.2663 1.02369 10.7337 4.92893 9.17157C8.83417 7.60947 15.1658 7.60947 19.071 9.17157",
    stroke: "url(#paint0_linear-sphere)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8284 4.92893C16.3905 8.83417 16.3905 15.1658 14.8284 19.071C13.2663 22.9763 10.7337 22.9763 9.17157 19.071C7.60947 15.1658 7.60947 8.83413 9.17157 4.92893C10.7337 1.02369 13.2663 1.02369 14.8284 4.92893",
    stroke: "url(#paint1_linear-sphere)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 4.92893C22.9763 8.83417 22.9763 15.1658 19.071 19.071C15.1658 22.9763 8.83413 22.9763 4.92893 19.071C1.02369 15.1658 1.02369 8.83413 4.92893 4.92893C8.83417 1.02369 15.1658 1.02369 19.071 4.92893",
    stroke: "url(#paint2_linear-sphere)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear-sphere",
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear-sphere",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear-sphere",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphere);
export default __webpack_public_path__ + "static/media/Sphere.22b7d9c2.svg";
export { ForwardRef as ReactComponent };